<template>
  <div class="dropdown-select-wrapper">
    <span class="focus"></span>
    <div
      data-test="cms-dropdown"
      class="dropdown-select"
      @click="openDropdownHandler()"
      :class="isOpen ? 'open' : ''"
    >
      <div class="dropdown-select__trigger">
        <span class="dropdown-default-answer">{{
          selectedAnswer?.answerLabel || "Pick an option"
        }}</span>
        <!-- <span :class="isOpen ? 'open' : ''"></span> -->
      </div>
      <div class="dropdown-options">
        <ul data-test="cms-dropdown-options">
          <li v-for="(data, index) in answers" :key="index">
            <span
              class="dropdown-option"
              :class="data.answerId === selectedAnswer?.answerId ? 'dropdown-option selected' : ''"
              @click="inputHandler(data)"
              :data-test="`cms-dropdown-option-${index}`"
              >{{ data.answerLabel }}</span
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import axios from "axios";
import { debug as d } from "debug";
import { computed, ref } from "vue";
import { SessionQuestionnaireApiModel } from "../../api-models";

const debug = d("cs.CmsDropdown");

export interface AnswerData {
  answerId: string;
  answerLabel: string;
}

const props = defineProps<{
  answers: AnswerData[];
  isShuffle: boolean;
  dropdownId: string;
  questionnaire: SessionQuestionnaireApiModel;
}>();

const isOpen = ref(false);

const previouslySelectedAnswer = computed<AnswerData | undefined>(() => {
  const previousAnswer: string[] | undefined = props.questionnaire.answers[props.dropdownId];
  const answerId = previousAnswer ? previousAnswer[0] : undefined;
  return props.answers.filter((answer) => answer.answerId === answerId)[0];
});

const selectedAnswer = ref<AnswerData | undefined>(previouslySelectedAnswer.value);

function shuffleArray(array: AnswerData[]): AnswerData[] {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }

  return array;
}

const answers = computed(() => {
  return props.isShuffle ? shuffleArray(props.answers) : props.answers;
});

function openDropdownHandler(): void {
  isOpen.value = !isOpen.value;
}

function inputHandler(answer: AnswerData): void {
  debug(answer.answerId);
  selectedAnswer.value = answer;
  axios
    .patch(`/api/sessionquestionnaire/${props.questionnaire?.id}/answers`, {
      [props.dropdownId]: [answer.answerId],
    })
    .then((resp) => {
      if (resp.status === 200) {
        debug("success!");
      }
    });
}
</script>

<style lang="less" scoped>
@import (reference) "../../styles/bootstrap/bootstrap.less";
@import (reference) "../../styles/bootstrap/variables.less";

*,
*::before,
*::after {
  box-sizing: border-box;
}
</style>
